import { render, staticRenderFns } from "./jobSetting.vue?vue&type=template&id=50f22270&"
import script from "./jobSetting.vue?vue&type=script&lang=js&"
export * from "./jobSetting.vue?vue&type=script&lang=js&"
import style0 from "./jobSetting.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports